import BaseService from "./BaseService";

class StaticPageTmpService extends BaseService {
  constructor(prefix) {
    super(prefix);
  }

  getStaticPagePreview(token) {
    return this.performRequest(BaseService.METHOD_GET, `${token}`);
  }
}

export default new StaticPageTmpService('static-page-previews');
